import { render, staticRenderFns } from "./MailForwardDataTable.vue?vue&type=template&id=159d2c5c&scoped=true"
import script from "./MailForwardDataTable.vue?vue&type=script&lang=js"
export * from "./MailForwardDataTable.vue?vue&type=script&lang=js"
import style0 from "./MailForwardDataTable.vue?vue&type=style&index=0&id=159d2c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159d2c5c",
  null
  
)

export default component.exports